// extracted by mini-css-extract-plugin
export default {"container":"redeemTemplate_container__1aiCg","logoContainer":"redeemTemplate_logoContainer__+gZoq"};